import React from 'react';

interface EmptyProps {
  title?: string;
  children?: React.ReactNode;
}

const Empty = (props: EmptyProps) => {
  const { title } = props;

  return (
    <div className="h-[130px] p-4 rounded bg-white w-full justify-center items-center">
      {props.children || (
        <p className="whitespace-pre-line text-neutral-500 text-center">
          {title}
        </p>
      )}
    </div>
  );
};

export default Empty;
